import { PackagingButtonDelete } from './ButtonDelete';

export const ButtonDelete = PackagingButtonDelete;
